import { RootState } from '../reducers'

export const getLeftSiderCollapsed = (state: RootState) =>
  state.layout.LeftSider.collapsed
export const getDocumentTitle = (state: RootState) =>
  state.layout.Document.title
